<template>
  <svg
    viewBox="0 0 130 25"
    xmlns="http://www.w3.org/2000/svg"
    :class="{ VvTitle: true, 'VvTitle--auto': auto, 'VvTitle--text': text }"
  >
    <path
      d="M23.088 3l-9.15 21h-3.84L.918 3h4.23l6.99 16.2L19.188 3h3.9zm8.005 21.21c-1.62 0-3.08-.35-4.38-1.05-1.3-.7-2.32-1.67-3.06-2.91-.72-1.26-1.08-2.68-1.08-4.26 0-1.58.36-2.99 1.08-4.23a7.793 7.793 0 013.06-2.91c1.3-.7 2.76-1.05 4.38-1.05 1.64 0 3.11.35 4.41 1.05 1.3.7 2.31 1.67 3.03 2.91.74 1.24 1.11 2.65 1.11 4.23 0 1.58-.37 3-1.11 4.26-.72 1.24-1.73 2.21-3.03 2.91-1.3.7-2.77 1.05-4.41 1.05zm0-3.21c1.38 0 2.52-.46 3.42-1.38.9-.92 1.35-2.13 1.35-3.63s-.45-2.71-1.35-3.63c-.9-.92-2.04-1.38-3.42-1.38s-2.52.46-3.42 1.38c-.88.92-1.32 2.13-1.32 3.63s.44 2.71 1.32 3.63c.9.92 2.04 1.38 3.42 1.38zm21.958 3l-4.11-5.55-4.14 5.55h-4.14l6.24-8.13-5.97-7.89h4.17l3.93 5.25 3.93-5.25h4.05l-6 7.83 6.27 8.19h-4.23zM88.2 3l-9.15 21h-3.84L66.03 3h4.23l6.99 16.2L84.3 3h3.9zm2.153 4.98h3.75V24h-3.75V7.98zm1.89-2.64c-.68 0-1.25-.21-1.71-.63-.46-.44-.69-.98-.69-1.62 0-.64.23-1.17.69-1.59.46-.44 1.03-.66 1.71-.66.68 0 1.25.21 1.71.63.46.4.69.91.69 1.53 0 .66-.23 1.22-.69 1.68-.44.44-1.01.66-1.71.66zm21.932 2.64L107.304 24h-3.87l-6.87-16.02h3.9l4.98 11.88 5.13-11.88h3.6zm8.116-.18c2.36 0 4.16.57 5.4 1.71 1.26 1.12 1.89 2.82 1.89 5.1V24h-3.54v-1.95c-.46.7-1.12 1.24-1.98 1.62-.84.36-1.86.54-3.06.54s-2.25-.2-3.15-.6c-.9-.42-1.6-.99-2.1-1.71-.48-.74-.72-1.57-.72-2.49 0-1.44.53-2.59 1.59-3.45 1.08-.88 2.77-1.32 5.07-1.32h4.14v-.24c0-1.12-.34-1.98-1.02-2.58-.66-.6-1.65-.9-2.97-.9-.9 0-1.79.14-2.67.42-.86.28-1.59.67-2.19 1.17l-1.47-2.73c.84-.64 1.85-1.13 3.03-1.47 1.18-.34 2.43-.51 3.75-.51zm-.51 13.68c.94 0 1.77-.21 2.49-.63.74-.44 1.26-1.06 1.56-1.86v-1.86h-3.87c-2.16 0-3.24.71-3.24 2.13 0 .68.27 1.22.81 1.62.54.4 1.29.6 2.25.6z"
      fill="#263238"
    />
  </svg>
</template>

<script setup lang="ts">
interface Props {
  auto?: boolean;
  text?: boolean;
}

const props = withDefaults(defineProps<Props>(), {});
</script>

<style lang="scss">
.VvTitle {
  &--text {
    width: auto;
    height: 1em;
  }

  &--auto {
    width: auto;
    height: 100%;
  }
}
</style>
